import { render, staticRenderFns } from "./ServiceReviewImages.vue?vue&type=template&id=4121eca6&scoped=true&"
import script from "./ServiceReviewImages.vue?vue&type=script&lang=js&"
export * from "./ServiceReviewImages.vue?vue&type=script&lang=js&"
import style0 from "./ServiceReviewImages.vue?vue&type=style&index=0&id=4121eca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4121eca6",
  null
  
)

export default component.exports